import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicensesComponent } from './pages/licenses/licenses.component';
import { LicensesRoutingModule } from './licenses-routing.module';
import { LicensesListTabComponent } from './components/licenses-list-tab/licenses-list-tab.component';
import { SearchBarModule } from 'src/app/angular-core/components/search-bar/search-bar.module';
import { EffectsModule } from '@ngrx/effects';
import { LicensesEffects } from 'src/app/store/effects/licenses.effects';
import { ShoppingBasketButtonComponent } from './components/shopping-basket-button/shopping-basket-button.component'
import { MatIconModule } from '@angular/material/icon';
import { OrderLicensesComponent } from './pages/order-licenses/order-licenses.component';
import { InputModule } from 'src/app/angular-core/components/input/input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LicenseFormatterService } from './services/license-formatter.service';
import { MatBadgeModule } from '@angular/material/badge';
import { FilterPipeModule } from 'src/app/angular-core/utils/pipes/filter/filter.pipe.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { DialogHeaderModule } from 'src/app/angular-core/components/dialog-header/dialog-header.module';
import { OrderHistoryComponent } from './pages/order-history/order-history.component';
import { ListItemModule } from 'src/app/angular-core/components/list-item/list-item.module';
import { OrderDetailsComponent } from './pages/order-details/order-details.component';
import { CompanyFilterModule } from '../../shared/components/company-filter/company-filter.module';
import { LocalizedDateModule } from 'src/app/angular-core/utils/pipes/localized-date/localized-date.pipe.module';
import { LocalizedDatePipe } from 'src/app/angular-core/utils/pipes/localized-date/localized-date.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';


@NgModule({
  declarations: [LicensesComponent, LicensesListTabComponent, OrderDetailsComponent, OrderHistoryComponent, ShoppingBasketButtonComponent, OrderLicensesComponent],
  imports: [
    CommonModule,
    LicensesRoutingModule,
    MatTabsModule,
    SearchBarModule,
    InputModule,
    MatIconModule,
    DialogHeaderModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    ListItemModule,
    MatBadgeModule,
    MatListModule,
    CompanyFilterModule,
    FilterPipeModule,
    ReactiveFormsModule,
    TranslateModule,
    MatTableModule,
    LocalizedDateModule,
    EffectsModule.forFeature([LicensesEffects]),
  ],
  providers: [
    LicenseFormatterService,
  ],
  exports: [
    LicensesComponent
  ]
})
export class LicensesModule { }
